import { Link } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { useColorModeValue } from "../ui/color-mode";

const SingleMenuItem = ({ url, icon, label, ...props }) => {
  const hovercolor = useColorModeValue("#008080", "#b3c0f8");
  return (
    <Link
      as={RouterLink}
      to={url}
      fontSize={{ base: "xl", md: "xs", lg: "sm" }}
      letterSpacing="wide"
      display="flex"
      alignItems="center"
      fontWeight="600"
      _hover={{ textDecor: "none", color: hovercolor }}
      onClick={() => {
        window.scrollTo({ top: "0", behavior: "auto" });
      }}
      _focus={{ outline: "none" }}
      {...props}
    >
      {label}
      {icon}
    </Link>
  );
};

export default SingleMenuItem;
